import React from 'react';
import PropTypes from 'prop-types';
import css from './SearchOption.scss';
import { range } from 'lodash';

const LinePlaceholder = () => (
  <div className={css['container']}>
    <div className={css['avatar-placeholder']} />
    <div className={css['lines-placeholder']}>
      <div className={css['title']}>&nbsp;</div>
      <div className={css['description']}>&nbsp;</div>
    </div>
  </div>
);

export default class SearchOptionPlaceholder extends React.Component {

  get lines() {
    return range(this.props.numberOfLines).map(index => <LinePlaceholder key={index} />);
  }

  render() {
    return <div className={css['placeholder-container']}>{this.lines}</div>;
  }
}

SearchOptionPlaceholder.defaultProps = {
  numberOfLines: 3
};

SearchOptionPlaceholder.propTypes = {
  numberOfLines: PropTypes.number.isRequired
};
